module.exports = __webpack_public_path__ + "img/recharge.36409f30.png";